import BroadcastsPageLayout from 'container/BroadcastsPageLayout'

const Broadcasts = () => <BroadcastsPageLayout />

export default Broadcasts
